import { ComponentProps, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import get from 'lodash/get';

import { FormSelectField } from '../components/form-select-field/form-select-field';

export const useAutoSelectIfEmpty = <T>(
  name: string,
  options: ComponentProps<typeof FormSelectField>['options'],
  selectFirstAsDefault = false
) => {
  const { watch, setValue } = useFormContext();
  const value = watch(name);

  useEffect(() => {
    const firstItemValue = get(options, [0, 'value']);
    if (selectFirstAsDefault && firstItemValue && !value) {
      setValue(name, firstItemValue);
    }
  }, [options, name, selectFirstAsDefault, setValue, value]);
};

export default useAutoSelectIfEmpty;
